export default __webpack_public_path__ + "static/media/RT_2.dc2a21f4.png";